import React, { useContext } from "react";
import { images } from "../Assets/images";
import { GlobalContext } from "../Context/GlobalContext";

const HeightSlider = ({ value, onChange }) => {
    const { translatedLabels } = useContext(GlobalContext);
    const authLabel = translatedLabels?.auth;
    const min = 48;
    const max = 84;
    const inchesToFeetInch = (inches) => {
        const feet = Math.floor(inches / 12);
        const inch = inches % 12;
        return `${feet} ft ${inch} in`;
    };

    const ticks = [];
    for (let i = min; i <= max; i++) {
        ticks.push(i);
    }

    return (
        <div className="height-slider-container">
            <div className="d-flex justify-content-between align-items-center">
                <label className="form-label question-label mb-0">{authLabel?.what_is_your_height?.label_value || "What is your height?"} <span className="text-danger">*</span></label>
                <span className="text-muted">{inchesToFeetInch(value)}</span>
            </div>

            <div className="d-flex align-items-center gap-2">
                <div className="input-image">
                    <img src={images.height} alt="height" />
                </div>
                <div className="w-100">
                    <div className="position-relative">
                        <div>
                            <input
                                type="range"
                                min={min}
                                max={max}
                                step="1"
                                value={value}
                                onChange={(e) => onChange(Number(e.target.value))}
                                className="height-slider"
                                style={{
                                    "--progress": `${((value - min) / (max - min)) * 100}%`,
                                }}
                            />
                        </div>

                        <div className="slider-ticks">
                            {ticks.map((tick, i) => {
                                const inch = tick % 12;
                                let heightClass = "small-tick";

                                if (inch === 0) heightClass = "large-tick";
                                else if (inch % 4 === 0) heightClass = "medium-tick";

                                return <div key={i} className={`tick-mark ${heightClass}`} />;
                            })}
                        </div>
                    </div>

                    <div className="d-flex justify-content-between tick-labels mt-2">
                        {[4, 5, 6, 7].map((ft) => (
                            <span key={ft} className="tick-label">
                                {ft} ft
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeightSlider;
